"use strict";
/**
 * 涨跌色 composable
 * 参考 quote-rank-v2 的实现方式
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpDownColor = useUpDownColor;
const vue_demi_1 = require("vue-demi");
const enum_1 = require("../common/enum");
const { useVariable } = require('@fegobull/webapi').use;
const { plugins: { weblib } } = require('@futuweb/fego-render');
const { nnq: NNQ } = weblib['@futuweb/tool-nn'];
/**
 * 涨跌色 composable
 * @param props 组件 props，包含 up_down_color 配置
 * @returns upDownColor - 当前涨跌色配置
 */
function useUpDownColor(props) {
    var _a;
    const { IS_NN, IS_MOOMOO } = useVariable();
    // 默认使用配置值，如果没有配置则使用绿涨红跌
    const upDownColor = (0, vue_demi_1.ref)((_a = props.up_down_color) !== null && _a !== void 0 ? _a : enum_1.UP_DOWN_COLOR.GREEN_UP);
    /**
     * 从客户端获取用户偏好设置
     */
    const setUpDownColor = () => {
        var _a;
        const run = () => {
            window.NNWebViewJSBridge.callHandler('getUpDownType', {}, (res) => {
                try {
                    const { result, data } = JSON.parse(res) || {};
                    // data: 涨跌色，0-红涨绿跌, 1-绿涨红跌, 2-粉涨绿跌, 3-绿涨粉跌
                    if (result === 0) {
                        upDownColor.value = [0, 2].includes(data) ? enum_1.UP_DOWN_COLOR.RED_UP : enum_1.UP_DOWN_COLOR.GREEN_UP;
                    }
                }
                catch (e) {
                    console.error('getUpDownType error:', e);
                }
            });
        };
        if ((_a = window === null || window === void 0 ? void 0 : window.NNWebViewJSBridge) === null || _a === void 0 ? void 0 : _a.callHandler) {
            run();
        }
        else {
            NNQ.initBridge({}, () => {
                run();
            });
        }
    };
    // 在客户端环境中获取用户偏好
    if (IS_NN || IS_MOOMOO) {
        (0, vue_demi_1.onBeforeMount)(setUpDownColor);
    }
    return {
        upDownColor
    };
}
//# sourceMappingURL=data:application/json;base64,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